module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0028-min.fdcc6a2e.jpg";